import React from "react"

import { connect } from "react-redux"

import { updateQuery, toggleExpanded, toggleLogoVisible } from "../../actions"

import mobileLogo from "../../images/nutrafol-logo-mobile.svg"
import desktopLogo from "../../images/nutrafol-logo.svg"

import styled from "@emotion/styled"
import { globalHistory } from "@reach/router"

import { queries } from "../../utils/mediaqueries.js"

const LogoArea = styled.div`
  display: inline-block;
  &.hidden {
    visibility: hidden;
    ${queries.medium`
      visibility: visible;
    `}
  }
  h1,
  h3 {
    margin: 0;
  }
  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: 10px;
    vertical-align: top;
  }
  @media (min-width: 825px) {
    margin-right: 15px;
  }
  @media (min-width: 1024px) {
    margin-right: 25px;
  }
  @media (min-width: 1120px) {
    margin-right: 35px;
  }
`
const LogoImageHolder = styled.div`
  .mobile-logo {
    height: 28px;
    width: 23px;
  }
  .desktop-logo {
    display: none;
  }
  @media (min-width: 768px) {
    padding: 37px 0 36px;
    .mobile-logo {
      display: none;
    }
    .desktop-logo {
      display: inline-block;
      width: 126px;
      height: auto;
    }
  }
`

const Logo = ({
  logoVisible,
  updateQuery,
  toggleExpanded,
  toggleLogoVisible,
}) => {
  const { pathname } = globalHistory.location

  const Wrapper = styled.div``

  return (
    <LogoArea className={logoVisible ? "logo-wrap" : "hidden"}>
      <Wrapper>
        <a
          href={process.env.GATSBY_MAGENTO_URL}
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LogoImageHolder>
            <span className="sr-only">{`Nutrafol Blog`}</span>
            <img src={mobileLogo} className="mobile-logo" alt="Nutrafol Logo" />
            <img
              src={desktopLogo}
              className="desktop-logo"
              alt="Nutrafol Logo"
            />
          </LogoImageHolder>
        </a>
      </Wrapper>
    </LogoArea>
  )
}

export default connect(null, {
  updateQuery,
  toggleExpanded,
  toggleLogoVisible,
})(Logo)
